module.exports = __webpack_public_path__ + "img/newsletter_background.327b523f.jpg";